import React from 'react';

// ── A count that reads as a count (24 Oct) ───────────────────────────────────
//
// Manny: "Any where there is a number that represents a ticket count, make it
// stand out more. Right now they look like an afterthought." One look for
// every such number: a filled pill, bold.
//   tone 'strong'  dark on light, light on dark (the theme's text colour)
//   tone 'orange'  the Parts to Order orange
//   inverse        on an already-filled background (an active tab)
// A zero is shown quieter, so a full list stands out from an empty one.

export default function CountPill({ n, T, tone = 'strong', inverse = false, size = 12, style = {} }) {
  const zero = !(Number(n) > 0);
  const bg = inverse ? 'rgba(255,255,255,0.25)'
    : zero ? 'transparent'
    : tone === 'orange' ? '#e67e22' : T.text;
  const fg = inverse ? 'inherit' : zero ? T.textSub : tone === 'orange' ? '#fff' : (T.card || T.bg || '#fff');
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: size + 10, height: size + 8,
      padding: '0 7px', boxSizing: 'border-box', borderRadius: (size + 8) / 2, fontSize: size, fontWeight: 700, lineHeight: 1,
      background: bg, color: fg, border: zero && !inverse ? `1px solid ${T.border || T.cardBorder || '#ccc'}` : 'none',
      fontVariantNumeric: 'tabular-nums', verticalAlign: 'middle', ...style,
    }}>{Number(n) || 0}</span>
  );
}
